<template>
	<section
		class="flex text-sm py-4 w-full md:px-20 px-6 justify-center box-border"
		style="background-color: #f7f7f7"
	>
		<div class="w-full box-border" style="max-width: 1366px">
			<Breadclumb :menu="breadclumb" />
			<h1 class="text-3xl md:text-3xl text-spc font-semibold">
				{{ title }}
			</h1>
			<h2
				class="text-2xl md:text-2xl text-spc font-semibold mb-6"
			>
				{{ subtitle }}
			</h2>
			<div
				class="flex flex-col md:grid grid-rows-1 mb-6 md:mb-9 gap-x-10 w-max max-w-full"
				style="grid-template-columns: max-content 1fr"
			>
				<svg
					width="48"
					height="48"
					class="w-12 h-12 place-self-center hidden md:block"
					viewBox="0 0 48 48"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M31.5 44.64H16.5L18 36H30L31.5 44.64V44.64Z"
						stroke="#2966F5"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M12 44.64H36"
						stroke="#2966F5"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M1.5 30.2399H46.5"
						stroke="#2966F5"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M1.5 4.43994C1.5 2.78308 2.84315 1.43994 4.5 1.43994H43.5C45.1569 1.43994 46.5 2.78309 46.5 4.43994V32.9999C46.5 34.6568 45.1569 35.9999 43.5 35.9999H4.5C2.84315 35.9999 1.5 34.6568 1.5 32.9999V4.43994Z"
						stroke="#2966F5"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
				<div
					class="flex flex-col md:grid grid-rows-1 gap-5"
					style="
						grid-template-columns: minmax(
								0,
								1fr
							) 440px;
					"
				>
					<div
						class="grid md:flex flex-col justify-center gap-4 md:gap-0 w-full"
						style="
							grid-template-columns: max-content 1fr;
						"
					>
						<svg
							width="48"
							height="48"
							class="w-12 h-12 place-self-center md:hidden"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M31.5 44.64H16.5L18 36H30L31.5 44.64V44.64Z"
								stroke="#2966F5"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M12 44.64H36"
								stroke="#2966F5"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M1.5 30.2399H46.5"
								stroke="#2966F5"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M1.5 4.43994C1.5 2.78308 2.84315 1.43994 4.5 1.43994H43.5C45.1569 1.43994 46.5 2.78309 46.5 4.43994V32.9999C46.5 34.6568 45.1569 35.9999 43.5 35.9999H4.5C2.84315 35.9999 1.5 34.6568 1.5 32.9999V4.43994Z"
								stroke="#2966F5"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						<p
							class="text-base font-normal text-gray-500"
						>
							{{ description }}
						</p>
						<div
							class="grid gap-x-5 col-span-2 md:col-span-1 md:col-start-1 md:row-start-2 mt-5 bg-white rounded-3xl w-full p-6 box-border"
							style="
								grid-template-columns: max-content 1fr;
							"
							v-if="
								warning !==
								undefined
							"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								class="row-start-1 row-end-3 place-self-center"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5ZM13 16.5H11V18.5H13V16.5ZM13 10.5H11V14.5H13V10.5Z"
									fill="#2966F5"
								/>
							</svg>

							<strong
								class="font-semibold text-gray-600"
								>ATENÇÃO:</strong
							>
							<p
								class="text-gray-500 col-start-2"
								v-html="warning"
							></p>
						</div>
					</div>
					<div
						class="w-full h-max md:col-span-1 col-span-2"
					>
						<div
							class="flex flex-col box-border h-max justify-start items-start leading-tight text-gray-500 bg-white rounded-md w-full p-4"
							style="
								box-shadow: 0px
										0px
										1px
										0px
										rgba(
											48,
											49,
											51,
											0.05
										),
									0px 8px
										16px
										0px
										rgba(
											48,
											49,
											51,
											0.1
										);
							"
						>
							<span
								>Mais
								informações
								sobre o seu
								sistema:</span
							>
							<strong
								class="text-sm text-gray-600 mt-2"
								>Sistema
								operacional é:
							</strong>
							<p
								class="text-spc text-lg font-bold"
							>
								{{
									getSystemInfo.os
								}}
								{{
									getSystemInfo.osVersion
								}}
							</p>
							<h4>
								Navegador:
								<strong
									class="text-spc"
									>{{
										getSystemInfo.browser
									}}</strong
								>
							</h4>
						</div>
					</div>
				</div>
			</div>
			<div
				class="flex flex-col md:grid"
				style="
					grid-template-columns: minmax(0, 1fr) 440px;
				"
			>
				<h3
					class="font-semibold md:text-left text-center text-2xl col-span-2 order-2 md:order-none text-gray-600 mb-2"
				>
					Siga o passo a passo da Instalação
				</h3>
				<p
					class="text-base mb-6 col-span-2 md:text-left text-center text-gray-500 order-2 md:order-none"
				>
					Simples, fácil e rápido.
				</p>
				<ul
					class="flex flex-col gap-4 mb-7 order-2 md:order-none"
				>
					<slot name="cards"></slot>
					<li
						class="li-opcao grid items-center text-center w-full"
						style="
							grid-template-columns: max-content minmax(
									0,
									1fr
								);
						"
					>
						<span
							class="grid place-items-center rounded-full bg-spc text-xl md:text-3xl w-12 h-12 text-white font-bold leading-none"
							>1</span
						>
						<div
							class="flex flex-col justify-start md:ml-4 box-border items-start bg-white rounded-md w-full p-4"
							style="max-width: 443px"
						>
							<h3
								class="text-left text-base text-spc font-bold"
							>
								Passo 1
							</h3>
							<p
								class="text-gray-600 text-sm col-start-2 text-left"
							>
								Acesse o link
								abaixo Emissão
								de Certificado
								Digital.
							</p>
							<div
								class="flex gap-2 w-full"
							>
								<a
									href="https://hope-accndl.safewebpss.com.br/pages/client/emission"
									:disabled="
										!linkDownload
									"
									target="_blank"
									class="flex justify-start align-items py-2 px-8 gap-x-2 w-max bg-spc-100 data-[disabled]:bg-gray-500 button-common focus-within:box-border mt-4 font-bold text-white rounded-full"
								>
									<img
										src="/certificacaodigital/images/instalacao/download.svg"
										class="w-5 h-5"
									/>
									Emissão
									Certificado
									Digital
								</a>
							</div>
						</div>
					</li>
					<li
						class="li-opcao grid items-center text-center w-full"
						style="
							grid-template-columns: max-content minmax(
									0,
									1fr
								);
						"
					>
						<span
							class="grid place-items-center rounded-full bg-spc text-xl md:text-3xl w-12 h-12 text-white font-bold leading-none"
							>2</span
						>
						<div
							class="flex flex-col justify-start md:ml-4 box-border items-start bg-white rounded-md w-full p-4"
							style="max-width: 443px"
						>
							<h3
								class="text-left text-base text-spc font-bold"
							>
								Passo 2
							</h3>
							<p
								class="text-gray-600 text-sm col-start-2 text-left"
							>
								Digite o
								protocolo, o CPF
								e a senha de
								instalação. Caso
								não se lembre da
								senha de
								instalação, você
								pode redefinir a
								senha.
							</p>
							<div
								class="flex gap-2 w-full"
							>
								<a
									href="https://revogacao.spc.org.br/#/auth/enviarRecuperacao"
									target="_blank"
									class="flex justify-start align-items py-2 px-8 gap-x-2 w-max bg-spc-100 data-[disabled]:bg-gray-500 button-common focus-within:box-border mt-4 font-bold text-white rounded-full"
								>
									<img
										src="/certificacaodigital/images/instalacao/download.svg"
										class="w-5 h-5"
									/>
									Redefinir
									a senha
								</a>
							</div>
						</div>
					</li>
					<li
						class="li-opcao grid items-center text-center w-full"
						style="
							grid-template-columns: max-content minmax(
									0,
									1fr
								);
						"
					>
						<span
							class="grid place-items-center rounded-full bg-spc text-xl md:text-3xl w-12 h-12 text-white font-bold leading-none"
							>3</span
						>
						<div
							class="flex flex-col justify-start md:ml-4 box-border items-start bg-white rounded-md w-full p-4"
							style="max-width: 443px"
						>
							<h3
								class="text-left text-base text-spc font-bold"
							>
								Passo 3
							</h3>
							<p
								class="text-gray-600 text-sm col-start-2 text-left"
							>
								Cadastre a senha
								de uso e faça
								download do
								aplicativo em
								seu dispositivo
								móvel.
							</p>
							<SelectOption
								:values="
									options
								"
								v-model="
									choices.plataform
								"
								placeholder="Plataforma"
								class="mt-4 w-full md:w-1/2 xl:w-1/2"
							/>
						</div>
					</li>
					<li
						class="li-opcao grid items-center text-center w-full"
						style="
							grid-template-columns: max-content minmax(
									0,
									1fr
								);
						"
					>
						<span
							class="grid place-items-center rounded-full bg-spc text-xl md:text-3xl w-12 h-12 text-white font-bold leading-none"
							>3</span
						>
						<div
							class="flex flex-col justify-start md:ml-4 box-border items-start bg-white rounded-md w-full p-4"
							style="max-width: 443px"
						>
							<h3
								class="text-left text-base text-spc font-bold"
							>
								Passo 4
							</h3>
							<p
								class="text-gray-600 text-sm col-start-2 text-left"
							>
								<strong
									>Pronto!</strong
								>
								Agora instale o
								SafeID Desktop
								em seu
								computador
							</p>
							<a
								href="https://pscsafeweb.safewebpss.com.br/desktop/setup.exe"
								download
								class="flex justify-center align-items py-2 px-8 gap-x-2 w-40 bg-spc-100 data-[disabled]:bg-gray-500 button-common focus-within:box-border mt-4 font-bold text-white rounded-full"
							>
								<img
									src="/certificacaodigital/images/instalacao/download.svg"
									class="w-5 h-5"
								/>
								Download
							</a>
						</div>
					</li>
					<li
						class="li-opcao grid items-center text-center w-full"
						style="
							grid-template-columns: max-content minmax(
									0,
									1fr
								);
						"
					>
						<span
							class="grid place-items-center rounded-full bg-spc text-xl md:text-3xl w-12 h-12 text-white font-bold leading-none"
							>5</span
						>
						<div
							class="flex flex-col justify-start md:ml-4 box-border items-start bg-white rounded-md w-full p-4"
							style="max-width: 443px"
						>
							<h3
								class="text-left text-base text-spc font-bold"
							>
								Passo 5
							</h3>
							<p
								class="text-gray-600 text-sm col-start-2 text-left"
							>
								Para vincular o
								Certificado
								Digital no seu
								computador, abra
								o aplicativo em
								seu dispositivo
								móvel e acesse
								opção
								computadores. Em
								seguida escaneie
								o QR Code
								disponível no
								SafeID Desktop.
							</p>
						</div>
					</li>
					<li
						class="li-opcao grid items-center text-center w-full"
						style="
							grid-template-columns: max-content minmax(
									0,
									1fr
								);
						"
					>
						<span
							class="grid place-items-center rounded-full bg-spc text-xl md:text-3xl w-12 h-12 text-white font-bold leading-none"
							>6</span
						>
						<div
							class="flex flex-col justify-start md:ml-4 box-border items-start bg-white rounded-md w-full p-4"
							style="max-width: 443px"
						>
							<h3
								class="text-left text-base text-spc font-bold"
							>
								Passo 6
							</h3>
							<p
								class="text-gray-600 text-sm col-start-2 text-left"
							>
								<strong
									>Pronto!</strong
								>
								O seu
								certificado está
								pronto para uso.
							</p>
						</div>
					</li>
				</ul>
				<div class="w-full h-max order-1 md:order-none">
					<div
						class="flex flex-col mb-4 box-border h-max justify-start items-start leading-tight text-gray-500 bg-white rounded-md w-full p-4"
						style="
							box-shadow: 0px 0px 1px
									0px
									rgba(
										48,
										49,
										51,
										0.05
									),
								0px 8px 16px 0px
									rgba(
										48,
										49,
										51,
										0.1
									);
						"
					>
						<h3
							class="text-gray-600 text-sm font-semibold mb-2"
						>
							Instruções
						</h3>
						<div
							class="relative h-max w-full"
						>
							<div
								style="
									padding: 56.25%
										0
										0
										0;
									position: relative;
								"
							>
								<iframe
									:src="
										vimeoPlayer
									"
									frameborder="0"
									style="
										position: absolute;
										top: 0;
										left: 0;
										width: 100%;
										height: 100%;
									"
									title="0"
								></iframe>
							</div>
						</div>
					</div>
					<p
						class="text-spc font-bold text-base leading-tight md:whitespace-pre-wrap md:text-left text-center"
					>
						{{
							"Acesse aqui o manual e \n vídeo de instalação."
						}}
					</p>
					<a
						:href="linkManual"
						target="_blank"
						class="bg-spc-100 py-3 text-base w-full focus-within:box-border mt-2 flex items-center gap-x-2 box-border justify-center md:w-max px-8 font-bold text-white rounded-full mb-10"
					>
						<img
							src="/certificacaodigital/images/instalacao/download.svg"
							class="w-5 h-5"
						/>
						Baixar Manual
					</a>
				</div>
			</div>
			<h2
				v-if="showInstall"
				class="text-2xl font-normal text-gray-600 mb-2"
			>
				Deseja instalar o certificado em outros
				computadores?
			</h2>
			<p
				v-if="showInstall"
				class="text-base font-normal text-gray-500 mb-5"
			>
				Acesse nosso
				<a
					download
					href="manual_instalacao.pdf"
					class="text-spc-100"
					target="_blank"
					>manual de instalação</a
				>
				do backup.
			</p>
			<h2 class="text-2xl font-normal text-gray-600 mb-2">
				Conte com o suporte do SPC Brasil
			</h2>
			<div class="w-full" style="max-width: 600px">
				<p
					class="text-base font-normal text-gray-500 mb-5"
				>
					Em caso de dúvidas, acesse nossos canais
					de atendimento clicando em
					<a
						onclick="javascript:window.xgen.maximizeEmbed();"
						class="text-spc-100 cursor-pointer"
						target="_blank"
						>"Olá, Posso ajudar?"</a
					>
				</p>
				<p
					class="text-base font-normal text-gray-500 mb-5"
				>
					Atendimento disponível de segunda a
					sexta-feira, das 8h às 18h.
				</p>

				<p
					class="text-base font-normal text-gray-500 mb-5"
				>
					Para facilitar o seu atendimento,
					<a
						href="https://anydesk.com/pt/downloads/thank-you?dv=win_exe"
						class="text-spc-100"
						target="_blank"
						>faça o download do Anydesk
						clicando aqui</a
					>. Essa ferramenta é necessária para que
					os nossos especialistas te auxiliem.
					Após a instalação, abra o Anydesk e
					informe o número do dispositivo, que
					será solicitado no atendimento.
				</p>

				<p
					class="text-base font-normal text-gray-500 mb-5"
				>
					Acesse nosso manual de instalação da
					extensão Web PK:
					<a
						href="/docs/suporte/instalacao/a1-sem-midia/a1_extensao_web_pki.pdf"
						class="text-spc-100"
						target="_blank"
						>clique aqui.</a
					>
				</p>
			</div>
		</div>
	</section>
</template>
<script>
import Breadclumb from "@/components/breadclumb";
import SelectOption from "@/components/inputs/SelectForm";

export default {
	props: {
		title: String,
		subtitle: String,
		showInstall: String,
		breadclumb: Array,
		description: String,
		warning: [String, undefined],
	},
	methods: {
		handleClickHelpMe() {
			const el = document.getElementById(
				"embed-minimized-title"
			);
			el.click();
		},
	},
	data() {
		return {
			choices: {
				plataform: "android",
			},
			options: [
				{
					id: "android",
					label: "Android",
				},
				{
					id: "ios",
					label: "IOS",
				},
			],
		};
	},
	computed: {
		linkDownload() {
			return this.choices.plataform === "android"
				? "https://pscsafeweb.safewebpss.com.br/desktop/setup.exe"
				: this.choices.plataform === "ios"
				? "https://pscsafeweb.safewebpss.com.br/desktop/setup.exe"
				: undefined;
		},
		vimeoPlayer() {
			return this.choices.plataform === "android"
				? "https://player.vimeo.com/video/1038600963?badge=0&autopause=0&title=0&byline=0&portrait=0&texttrack=pt&controls=1&app_id=58479"
				: this.choices.plataform === "ios"
				? "https://player.vimeo.com/video/1038601014?badge=0&autopause=0&title=0&byline=0&portrait=0&texttrack=pt&controls=1&app_id=58479"
				: null;
		},
		linkManual() {
			return this.choices.plataform === "android"
				? "/certificacaodigital/docs/suporte/instalacao/a3-safe-id/a3_safe_id_manual_android.pdf"
				: "/certificacaodigital/docs/suporte/instalacao/a3-safe-id/a3_safe_id_manual_ios.pdf";
		},
		getSystemInfo() {
			const userAgent = navigator.userAgent;
			const platform = userAgent;
			let os = "";
			let browser = "";
			let osVersion = "";

			// Detectando o sistema operacional e sua versão
			if (platform.indexOf("Win") !== -1) {
				os = "Windows";
				// Verifica se a plataforma é de 64 bits
				osVersion +=
					userAgent.indexOf("Win64") !== -1 ||
					userAgent.indexOf("x64") !== -1
						? "- 64bit"
						: "- 32bit";
			} else if (
				platform.indexOf("Mac") !== -1 ||
				userAgent.indexOf("iPad") !== -1 ||
				userAgent.indexOf("iPhone") !== -1
			) {
				os =
					platform.indexOf("Mac") !== -1
						? "Mac OS"
						: "iOS";

				// Para macOS e iOS, não retorna a versão
				osVersion = "";
			} else if (platform.indexOf("X11") !== -1) {
				os = "UNIX";
				osVersion = "";
			} else if (platform.indexOf("Linux") !== -1) {
				os = "Linux";
				osVersion = "";
			}

			// Detectando o navegador
			if (userAgent.indexOf("Firefox") !== -1) {
				browser = "Firefox";
			} else if (userAgent.indexOf("Chrome") !== -1) {
				browser = "Chrome";
			} else if (
				userAgent.indexOf("Safari") !== -1 &&
				userAgent.indexOf("Chrome") === -1
			) {
				browser = "Safari";
			} else if (
				userAgent.indexOf("MSIE") !== -1 ||
				userAgent.indexOf("Trident") !== -1
			) {
				browser = "Internet Explorer";
			} else if (userAgent.indexOf("Edge") !== -1) {
				browser = "Edge";
			}

			return { browser, os, osVersion };
		},
	},
	components: {
		Breadclumb,
		SelectOption,
	},
};
</script>
<style>
a[disabled] {
	cursor: default;
	pointer-events: none;
}
</style>
